// --------------------------------------------------------------------------
// Password Toggle
// --------------------------------------------------------------------------
// Author:      Mike Simmonds
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;
	var passwordToggle = context.find('[data-binding="password-toggle"]');

	function init() {

		passwordToggle.each(function () {
			var passwordVisible = true;
			var $passwordInput = $('[data-ref="field"]');
			var $textInput = $passwordInput.clone().attr('type', 'text');
			var $trigger = context.find('[data-name="password-button"]');
			var $triggerShowText = $trigger.attr('data-show-password');
			var $triggerHideText = $trigger.attr('data-hide-password');

			$trigger.addClass('active');

			$trigger.on('click', function () {
				// Flip the toggle
				passwordVisible = !passwordVisible;

				// Update UI
				if (passwordVisible) {
					// Update password input value and insert into DOM
					$passwordInput.val($textInput.val()).insertAfter($textInput);

					// Detach text input
					$textInput.detach();

					// Update CTA
					$trigger.text($triggerShowText);
				} else {
					// Update text input value and insert into DOM
					$textInput.val($passwordInput.val()).insertAfter($passwordInput);

					// Detach password input
					$passwordInput.detach();

					// Update CTA
					$trigger.text($triggerHideText);
				}
			});
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/password-toggle.js
// module id = 275
// module chunks = 0